<app-base-modal
  [title]="testingResultFilesResourceType.name"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="testing-result-files-wrapper">
    @for (data of testingResultFilesData(); track $index) {
      <app-file-card
        [fileCard]="{
          id: data.id,
          fileParams: data.file,
          fileType: testingResultsFileType,
          isEditModeActive: isEditModeActive,
          shouldCheckImageType: false
        }"
        (handleDelete)="handleDelete($event, data.id)"
      />
    } @empty {
      <div class="testing-result-files-empty">
        Нет файлов
      </div>
    }
    <app-file-upload-card
      [fileUploadParams]="{
        parentId: testingResultId(),
        recordId: testingResultId(),
        type: testingResultsFileType,
        entityFileType: testingResultsFileType
      }"
      (attachFile)="attachFile($event)"
    />
  </div>
  <mat-form-field
    appearance="outline"
    class="testing-result-files-form-field"
    [class.none-pointer-events]="!isEditModeActive"
  >
    <mat-label>Комментарий</mat-label>
    <textarea
      matInput
      cdkTextareaAutosize
      cdkAutosizeMinRows="5"
      cdkAutosizeMaxRows="7"
      placeholder="Введите комментарий"
      [(ngModel)]="testingResultFilesDialogData.comment"
      (keydown.enter)="handleUpdateComment()"
      (blur)="handleUpdateComment()"
    ></textarea>
  </mat-form-field>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
